// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthFail_container__1TgFY","image":"AuthFail_image__3Jakd","label":"AuthFail_label__wpi71"};